<ngx-spinner type="ball-spin-clockwise" bdColor="rgba(255, 255, 255, 0.7)" size="medium" color="#ef870a" [fullScreen]="true"></ngx-spinner>
        
<div id="layoutHome">
    <div>
        <div class="d-flex align-items-center w-100 mb-2" style="flex-direction: column;">
            <div class="mt-4 align-items-center justify-content-center w-100 text-center">
                <span class="fm-prompt weight-500" style="font-size: 1.429rem;color: #0F0F1F;">
                    <span *ngIf="!isAddons()">Select your {{ order?.meals_per_day && order?.days_per_week ? (order.meals_per_day * order.days_per_week) : '' }} Meals</span>
                    <span *ngIf="isAddons()">Select your Add-ons</span>
                </span>
            </div>
            
            <app-meals-search-bar
                [isMobile]="isMobile"
                [meals]="allWeekMeals"
                [hideCategories]="isAddons()"
                (selectedTagChange)="onMealsSearchChange($event)"
                (selectedCategoryChange)="onMealsSearchChange($event)"
                (searchChange)="onMealsSearchChange($event)"
                (searchReset)="resetSearch()">
            </app-meals-search-bar>

        </div>
    </div>
    <div class="web-center">
        <div class="w-100 row mt-4 row mb-5 pb-3 mx-auto" *ngIf="visualWeekMeals.length>0" 
            [style]="!isMobile ? 'max-width: 1020px;' : (AddedMealsWeek.length > 0 && mealPopUpVisibility === false ? 'width: 100%; padding-bottom: 120px;' :'width: 100%;')">

            <app-new-meal-card
                *ngFor="let meal of visualWeekMeals"
                [meal]="meal"
                (addMeal)="addMeal($event)"
                (decreaseQuantity)="decreaseCount($event)"
                (increaseQuantity)="increaseCount($event)"
                (removeMeal)="removeMeal($event)">
            </app-new-meal-card>


        </div>
        <div *ngIf="visualWeekMeals.length==0 && !loading" class="d-flex flex-direction-column align-items-center" style="margin-top: 10%;">
            <span class="mb-4 mt-5">No meals found</span>
            <button class="btn btn-primary btn-add-to-cart weight-500 fm-prompt mb-4" (click)="resetSearch()">Clear search</button>
        </div>
    </div>
</div>
<div class="footer-custom-addons" *ngIf="mealsModel.length>0">
    <div style="padding-top: 1rem; padding-bottom: 1rem; width: 100%; max-width: 1420px; margin: 0 auto">
        <div class="fm-rubik" style="align-items: center; font-size: 1.143rem;" [ngClass]="isMobile? 'justify-content-center' : 'd-flex justify-content-between'">
            <div [ngClass]="isDesktop ? 'd-flex' : ''" [style]="!isMobile ? 'margin-left: 40px;' : ''">
                <div class="mx-auto web-left">
                    <div class="mb-2" style="display: flex; align-items: center; justify-content: center;">
                        <span class="t-black" [style]="!isMobile ? 'font-size: 3.357rem;' : 'font-size: 25px;'" >{{getTotalElementsWeek()}}</span>
                        <div class="d-flex">
                            <span class="weight-400 t-black"><span *ngIf="!isAddons()">/ {{(order.meals_per_day * order.days_per_week)}} </span>&nbsp; selected</span>
                            <i class="pi mx-1 fs08" style="cursor: pointer;font-size: 1.5rem;"
                                (click)="showCheckoutDetails('selectedMeals')"
                                [ngClass]="selectedMealsTrigger ? 'pi-angle-up' : 'pi-angle-down'">
                            </i>
                        </div>
                    </div>
                    <div *ngIf="selectedMealsTrigger">
                        <div *ngFor="let item of AddedMealsWeek" class="mb-1" [style]="isMobile ? 'margin-left: 10px; width: 90%' : ''">
                            <span style="cursor: pointer;" (click)="removeMeal(item)" class="remove-meal">
                                <i class="pi pi-times mx-1 fs08"></i>
                            </span>&nbsp;
                            <span style="margin-right: 1rem;font-style: italic;">{{item.name}}</span>
                            <span class="fm-rubik weight-500" style="float: right;">×{{item.count}}</span>
                        </div>
                       
                    </div>
                </div>
            </div>
            
            <!-- Apply to all remaining weeks checkbox by default
            <div class="mx-auto">
                <p-checkbox [(ngModel)]="selectedAllWeeks" [binary]="true" styleClass="rounded-checkbox"></p-checkbox>
                <span style="margin-left:5px">Apply to all remaining weeks</span>
            </div>
            -->
            <div *ngIf="!isMobile && !loading">
                <!-- Confirm button for Meals -->
                <button *ngIf="!isAddons()" class="btn btn-primary weight-500 getStartButton fm-prompt-button" style="margin-right: 40px;" (click)="updateOrderDetails()"
                    [disabled]="getTotalElements() < ((order?.meals_per_day && order?.days_per_week) ? (order.meals_per_day * order.days_per_week) : 0)">
                    <span>Confirm</span>
                    <i class="pi pi-arrow-right text-white arrow-icon"></i>
                </button>

                <!-- Confirm button for Add-ons -->
                <button *ngIf="isAddons()" class="btn btn-primary weight-500 getStartButton fm-prompt-button" style="margin-right: 40px;" (click)="updateOrderDetails()"
                    [disabled]="getTotalElements() < 1">
                    <span>Confirm</span>
                    <i class="pi pi-arrow-right text-white arrow-icon"></i>
                </button>
            </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="isMobile">
            <button class="btn btn-primary weight-500 getStartButton fm-prompt-button" (click)="updateOrderDetails()"
                *ngIf="!isAddons() && getTotalElements() == ((order?.meals_per_day && order?.days_per_week) ? (order.meals_per_day * order.days_per_week) : 0)">
                <span>Save and confirm</span>
                <i class="pi pi-arrow-right text-white arrow-icon"></i>
            </button>

            <!-- Confirm button for Add-ons -->
            <button class="btn btn-primary weight-500 getStartButton fm-prompt-button" (click)="updateOrderDetails()"
                *ngIf="getTotalElements() > 0 && isAddons()">
                <span>Save and confirm</span>
                <i class="pi pi-arrow-right text-white arrow-icon"></i>
            </button>
        </div>
    </div>
</div>


<p-dialog
        [draggable]="false"
        [resizable]="false"
        [closable]="false"
        header="Header"
        [blockScroll]="true"
        [(visible)]="donePopupVisibility"
        [style]="{ width: dialogWidth }"
        [styleClass]="!isMobile ? 'custom-dialog-addons' : 'custom-dialog-mobile-addons'"
        (onHide)="closeConfirm()">
    <ng-template pTemplate="header">
        <div class="mt-4 align-items-center justify-content-center w-100 text-center">
            <img src="assets/images/task-done.png" style="width: 43px;height: 43px;" alt="">
            <br>
            <br>
            <span class="fm-prompt weight-500" style="font-size: 1.429rem;color: #0F0F1F;">Done!</span>
        </div>
    </ng-template>
    <div class="mt-1 p-2 text-center">
        <span style="font-size: 14px; font-weight: 400;">
            You successfully changed your meals.
        </span>
    </div>
    <div class="mt-4 p-2 d-flex" style="text-align: center; flex-direction: column; align-items: center;">
        <button class="btn btn-orange-animation fm-prompt weight-500 mb-3" (click)="closeConfirm()"
                style="color: white;background-color: #EF870A;font-size: 1.143rem;border-radius: 12px;padding-top: 0.5rem;padding-bottom: 0.5rem;width: 40%;">
            Go to my profile
        </button>
    </div>
</p-dialog>